/**
 * Lendmarq stand-in for tpo-portal-frontend's brand system.
 *
 * tpo lets an admin define and switch between correspondent brands (logo,
 * colors, header size) held in a `brand` redux slice. lendmarq-los has no such
 * concept — it is single-partner and picks its identity off
 * `REACT_APP_PARTNER_NAME` via `useEnv` — so this module keeps the SHAPE the
 * vendored components read (`selectActiveBrand(state)` → a normalized brand
 * object) and answers it statically. No slice is registered, and the selector
 * deliberately ignores `state`.
 *
 * Keeping the selector rather than editing the ~6 vendored call sites means a
 * future re-sync from tpo drops in cleanly.
 */

// Lendmarq brand blue — the same value the recolor table in CLAUDE.md maps
// every Eastview teal onto. Keep these in step with that table.
const LENDMARQ_BLUE = "#1F5AF2";

const BRAND = {
  id: "lendmarq",
  name: "Lendmarq",
  displayName: process.env.REACT_APP_DISPLAY_NAME || "Lendmarq",
  // No uploaded logo: BrandLogo renders the Lendmarq wordmark vector.
  logoDataUrl: null,
  headerSize: "md",
  logoScale: 56,
  primaryColor: LENDMARQ_BLUE,
  secondaryColor: LENDMARQ_BLUE,
  // The public forms' left rail and mobile header are painted in this pair.
  // tpo uses near-black (#0F172A) on white text; Lendmarq wants a WHITE rail,
  // so the pair is inverted. Everything on the rail — muted text, hairlines,
  // the progress bar, the step markers and their connector line — is derived
  // from `headerFg` at varying alpha, so flipping these two values inverts the
  // whole rail correctly without touching PublicFormProgressRail.
  headerBg: "#FFFFFF",
  headerFg: "#0F172A",
};

export const normalizeBrand = (brand) => ({ ...BRAND, ...brand });

/** The brand applied across the vendored surfaces. `state` is unused. */
export const selectActiveBrand = () => BRAND;

export default BRAND;
